import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";
import { HomepageOperatorPersonas } from "@/design-system/patterns/homepage-operator-personas";
import { HomepageSubcontract } from "@/design-system/patterns/homepage-subcontract";

export default function OpcPageEn() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItemsEn} actionItems={siteHeaderActionsEn} homeHref="/en" />
      <main className="relative z-10 w-full overflow-hidden">
        <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-5xl">
            <div className="mb-8">
              <BrutalistBadge bgClass="bg-[#F97316]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
                OPC MODEL
              </BrutalistBadge>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
              One-Person Company Model
            </h1>
            <p className="text-lg font-bold text-zinc-600 mb-8">
              How OPCs monetize capabilities through Hotlines.
            </p>
            <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
              <p className="text-sm font-bold text-zinc-800">
                ⚠️ This page describes CALL ANYTHING's commercialization vision. The Marketplace is currently in Preview—fiat settlement is not yet available.
              </p>
            </div>

            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">Core Idea</h2>
              <p className="text-sm text-zinc-700">
                However human companies subcontract, the Hotline network subcontracts the same way. One person, one craft, one standardized Hotline—any Agent worldwide can discover and invoke it via protocol.
              </p>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">Why OPCs</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• Experience and judgment are the scarcest supply</li>
                    <li>• AI Agents need external professional capabilities</li>
                    <li>• Hotlines make individual skills globally callable</li>
                    <li>• The protocol layer handles identity, metering, and routing</li>
                  </ul>
                </div>
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">Revenue Model</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• Per-call billing—auto-settled when Agents consume</li>
                    <li>• Core logic stays local, protecting knowledge moats</li>
                    <li>• 24/7 automated response, no timezone constraints</li>
                    <li>• Iterative versioning compounds returns</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <HomepageOperatorPersonas />
        <HomepageSubcontract />
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}
